import { CalendarEventEditScope } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApplyToOccurrencesDialog } from 'shared/dialogs/apply-to-occurrences';

export type EventApplyToOccurrencesDialogProps = {
  onSelect: (editScope: CalendarEventEditScope) => void;
  onClose: () => void;
};

// Binds the calendar-event copy onto the shared prompt; both the save path and the drag
// path ask the same question, so neither owns the wording.
export const EventApplyToOccurrencesDialog: React.FC<
  EventApplyToOccurrencesDialogProps
> = ({ onSelect, onClose }) => {
  const { t } = useTranslation();

  const onSingle = () => onSelect(CalendarEventEditScope.Single);
  const onSeries = () => onSelect(CalendarEventEditScope.Series);

  return (
    <ApplyToOccurrencesDialog
      open
      abovePopups
      title={t('forms.event.edit-scope.title')}
      message={t('forms.event.edit-scope.description')}
      singleLabel={t('forms.event.edit-scope.single')}
      allLabel={t('forms.event.edit-scope.series')}
      onSingle={onSingle}
      onAll={onSeries}
      onCancel={onClose}
    />
  );
};
